const style = theme => ({
  linkPanel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    width: '100%',
  },
})

export default style
